import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { Store_formData } from '../../actions/InterBranchCoordinatorAction'
import { bookConsultNowTopNavMenus } from '../../Helpers/InterBranchConstants'
import BookConsultNowRoutes from '../../Routes/InterbranchRoutes/BookConsultNowRoutes'
import {fetch_consultationNow} from "../../actions/InterBranchCoordinatorAction"
import './bookconsultnow.css'

function BookConsultNow({ key }) {

    let [activeTop, setActiveTop] = useState(bookConsultNowTopNavMenus[0])

    
    
    let history = useHistory()
    let { path, url } = useRouteMatch();
    const { pathname } = useLocation();
    let reduxData = useSelector(state => state);
    let userDetails = JSON.parse(localStorage.getItem("userData"))
    let patientId = "";//**** IMPORTANT: Pass the patient Id */
    let nurseId = userDetails.userId;//**** IMPORTANT: Pass the nurse Id*/
    let UserType= userDetails.userType;
    
    let savedBookAppointmentForms = useSelector(state => state?.interBranchCoordinator?.saved_book_appointment_form)
    let savedScheduleAppointmentForms = useSelector(state => state?.interBranchCoordinator?.saved_schedule_appointment_form)
    let appointment_form = useSelector(state => state?.interBranchCoordinator?.appointment_form)
    const MINUTE_MS = 10000;
    let dispatch=useDispatch()

    let {
        //Patient details data....................................
        patientName, patientNumber, aadhaarNumber,gender,

        //Choose doctor data.....................................
        specialisation, chosendoctorId, typeOfConsultation, couponCode

        //Patient Medical data.....................................
        //(-- Need to add --)

        //Patient Consultation History data..........................
        //(-- Need to add --)



    } = reduxData?.interBranchCoordinator?.appointment_form

    let handleMenuClick = ({ target, key }) => {

        if (isTabActive(key.name)) {

            setActiveTop(key)
            history.push(`${path}/${target}`)
        }


        // console.log(`${path}/${target}`);
    }


    useEffect(() => {
     //   consultationnow()
        // history.push(`${path}/patientdetails`)
    }, [])



    useEffect(() => {

        bookConsultNowTopNavMenus.forEach(element => { pathname.includes(element.target) && setActiveTop(element) })

    }, [pathname])

    let isTabActive = (e) => {


        if (e == "Patient Details") {

            return true
        }
        else if (e == "Choose Doctor") {

            if (patientName, patientNumber,gender) {
                return true
            }
        }
        else if (e == "Patient Medical History" || e == "Patient Consultation History") {

            if (specialisation, chosendoctorId, typeOfConsultation, couponCode) {
                return true
            }
        }

        //  return true

    }

    let getTabClass = (element) => {

        let classes = []

       

        if (pathname.includes(element.target)) {
            classes.push("active-elements")
        }

        else if (!isTabActive(element.name)) {

            classes.push("disabled-elements")
        }


        return classes.toString().replace(/,/g, " ")
    }

    let isScheduled = () => {

        return url.includes("scheduleappointment")?"schedule":"book"

    }

    useEffect(() => {

        setActiveTop(bookConsultNowTopNavMenus[0])
        // const interval = setInterval(() => {
        //     consultationnow()
        //   }, MINUTE_MS);
        
        //   return () => clearInterval(interval);
    }, [isScheduled()])

    let isScheduleContext = () => {
        if (path.includes("scheduleappointment")) {
            return true
        }
    }

    function consultationnow()
    {
     //findConsultationForNow
     try {
         dispatch(fetch_consultationNow(nurseId)).then((data) => {
           
 
            /* if(data.appointmentId!=undefined)
           {
             setConsultationnowstatus(true)
             setconsultationnowDetails(data);
            
           }
           else
           {
             setConsultationnowstatus(false)
           }  */
 
         }); 
     }catch (error) {
         console.log("Error in fetch_clinic_speciality API",error);
     } 
    }


    return (
        <div className='book-consult-now-container' key={isScheduled()}>

            <div className="header">
                <div className="book-nav">
                    <ul >
                        {
                            bookConsultNowTopNavMenus.map((element, _key) => {

                                return (
                                    <li
                                        key={_key+key}
                                        className={getTabClass(element)}
                                        onClick={() => { handleMenuClick({ target: element.target, key: element }) }}
                                    >{element.name}</li>
                                )
                            })
                        }
                    </ul>
                </div>
            </div>



            <div className="data-container">
                {/* {activeTop.component} */}
                <BookConsultNowRoutes />
            </div>

        </div>
    )
}

export default BookConsultNow
